// 拡張子の集計（ファイル本文は読まない。件数のみ）。行数は必ず有界。
const TOP = 12;

const Row = ({ rows, testId }) => (
  <div className="flex flex-wrap gap-1.5" data-testid={testId}>
    {rows.slice(0, TOP).map((r) => (
      <span key={r.ext} className="px-2 py-0.5 rounded border border-zinc-200 bg-white text-[11px] text-zinc-700">
        <span className="font-mono">{r.ext || '(なし)'}</span>{' '}
        <b className="tabular-nums">{r.count}</b>
      </span>
    ))}
    {rows.length > TOP && (
      <span className="px-2 py-0.5 text-[11px] text-zinc-500">
        他 {rows.length - TOP} 種類 / {rows.length - TOP} more
      </span>
    )}
  </div>
);

export function NasExtensionSummary({ aggregate }) {
  const all = aggregate?.extension_counts || [];
  const unsupported = aggregate?.unsupported_extension_counts || [];
  if (!all.length && !unsupported.length) return null;
  return (
    <div data-testid="nas-detail-extensions">
      <p className="text-[12px] font-semibold text-zinc-700 mb-1.5">
        拡張子の内訳 <span className="text-[10.5px] font-normal text-zinc-400">Extensions</span>
      </p>
      {all.length > 0 && (
        <>
          <p className="text-[10.5px] text-zinc-500 mb-0.5">
            検出したすべての拡張子 / All observed ({all.length} 種類)
          </p>
          <Row rows={all} testId="nas-detail-ext-all" />
        </>
      )}
      {unsupported.length > 0 && (
        <>
          <p className="text-[10.5px] text-zinc-500 mt-1.5 mb-0.5">
            対象外の拡張子（取り込みません） / Unsupported ({unsupported.length} 種類)
          </p>
          <Row rows={unsupported} testId="nas-detail-ext-unsupported" />
        </>
      )}
    </div>
  );
}

export default NasExtensionSummary;
